import { useCallback } from 'react'
import { IconButton } from '@mui/material'
import { Box } from '@mui/system'

const NodeToggleIcon = ({
  sx,
  buttonSx,
  keepSpace = true,
  displayed = true,
  loading = false,
  node,
  onClick,
  onLoadChildren
}) => {
  const handleClick = useCallback(async (e) => {
    e.stopPropagation()
    
    if (!node.isOpen && node.children.length === 0) {
      if (onLoadChildren) {
        await onLoadChildren()
      }
    }
    
    if (onClick) {
      onClick()
    }
  }, [onClick, onLoadChildren, node])

  const isOpen = node.isOpen && node.children.length > 0
  
  return (
    <Box
      sx={{
        ...sx,
        ...{ display: displayed || keepSpace ? 'flex' : 'none' }
      }}
      alignItems="center"
      justifyContent="center">
      <IconButton
        size='small'
        disableRipple
        onClick={handleClick}
        sx={{
          ...buttonSx,
          width: '20px',
          fontSize: '14px',
          maxHeight: '10px',
          color: '#656565',
          p: 0,
          ...{ visibility: displayed ? 'visible' : 'hidden' },
          cursor: loading ? 'wait' : 'pointer',
          transform: isOpen ? 'rotate(90deg)' : 'rotate(0deg)',
          transition: 'transform 160ms ease, color 160ms ease'
        }}>
        {loading ? (
          <i className="fa-solid fa-spinner fa-spin" />
        ) : (
          <i className="fa-solid fa-chevron-right" />
        )}
      </IconButton>
    </Box>
  )
}

export default NodeToggleIcon
